import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { MessageService } from '@services/helpers/message-service/message.service';
import { LeadsDataServiceProvider } from '@services/lead/leads.data.service';

@Component({
	selector: 'delete-lead-modal',
	template: require('./delete-lead-modal.html')
})
export class DeleteLeadModalComponent implements OnInit {
	@Input() leadForDelete: number;
	@Output()
	updateParentTrigger: EventEmitter<boolean> = new EventEmitter<boolean>();
	disableButtons: boolean;
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private messageService: MessageService,
		private leadDataService: LeadsDataServiceProvider
	) {}

	ngOnInit() {}

	deleteLead(): void {
		this.disableButtons = true;

		this.leadDataService
			.deleteLead(this.leadForDelete)
			.finally(() => (this.disableButtons = false))
			.subscribe(
				() => {
					this.messageService.showToaster('s_2', 'lead');

					$('#deleteLeadModal').modal('hide');
					this.updateParentTrigger.emit(true);
					this.updateGraphsModel(['leads', 'shoots', 'payments']);
				},
				error => this.errorDeleteLead(error)
			);
	}

	private errorDeleteLead({ status, data }) {
		const errorMessage = data.errorMessage;
		let errorCode, errorPlace, value;

		if (status >= 400 && status < 500 && errorMessage) {
			if (
				errorMessage.includes(
					'This payment cannot be marked as unpaid because it was overpaid in Xero.'
				)
			) {
				errorCode = 'e_12';
				errorPlace = 'xero';
				value = 'job';
			} else {
				errorCode = 'e_2';
				errorPlace = 'general';
				value = errorMessage;
			}
		} else {
			errorCode = 'e_0';
			errorPlace = 'general';
		}
		this.messageService.showToaster(errorCode, errorPlace, value);
	}

	private updateGraphsModel = function(tabs) {
		window.snCommunicationAdapter.callMethod('updateGraphsModel', tabs);
	};
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/leads/modals/delete-lead-modal/delete-lead-modal.ts